import { render } from "./ClientReportesUtilidadAproximada.vue?vue&type=template&id=5599ca00&scoped=true"
import script from "./ClientReportesUtilidadAproximada.vue?vue&type=script&lang=js"
export * from "./ClientReportesUtilidadAproximada.vue?vue&type=script&lang=js"

import "./ClientReportesUtilidadAproximada.vue?vue&type=style&index=0&id=5599ca00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5599ca00"]])

export default __exports__